"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileMd5 = void 0;
var spark_md5_1 = require("spark-md5");
var types_1 = require("./types");
var utils_1 = require("./utils");
var getFileMd5 = function (file) {
    var blobSlice = File.prototype.slice;
    var chunkSize = 2097152;
    var chunks = Math.ceil(file.size / chunkSize);
    var currentChunk = 0;
    var spark = new spark_md5_1.ArrayBuffer();
    var fileReader = new FileReader();
    return new Promise(function (resolve, reject) {
        fileReader.onload = function (e) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            spark.append(e.target.result);
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
            }
            else {
                resolve(spark.end());
            }
        };
        fileReader.onerror = function (error) {
            reject(new utils_1.Error({
                code: types_1.ErrorCode.CheckFileFail,
                message: 'Get file etag failed',
                error: error
            }));
        };
        function loadNext() {
            var start = currentChunk * chunkSize;
            var end = start + chunkSize >= file.size ? file.size : start + chunkSize;
            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }
        loadNext();
    });
};
exports.getFileMd5 = getFileMd5;
